<template>
  <div class="car_rent_order">
    <div class="car_rent_order_nav">
      <navbar
        title="订单详情"
        :lefticon="lefticon"
        :lefticonheight="2.4"
        :lefticonwidth="2.4"
        :fontweight="700"
        :fontsize="'1.7rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="all">
      <div class="box">
        <van-row class="goods">
          <van-col span="24" class="status"
            >{{ statusLabel[detailInfo.status] }}
            <span
              class="operation"
              v-if="detailInfo.status != -40"
              @click="goSign"
              >{{ detailInfo.status == 40 ? "签署合同" : "点击查看合同" }}</span
            ><span
              class="operation"
              v-if="detailInfo.status == -40"
              @click="goSign"
              >重新签署合同</span
            ></van-col
          >
          <van-col
            span="24"
            class="tips tips_top"
            v-if="detailInfo.status == -40"
            ><img src="../../assets/carRent/tips@2x.png" />{{
              detailInfo.remark
            }}</van-col
          >
          <van-col span="24" class="goods_info">
            <img
              v-if="
                detailInfo.car_order_goods && detailInfo.car_order_goods.images
              "
              :src="detailInfo.car_order_goods.images[0]"
            />
            <div class="goods_r" v-if="detailInfo.car_order_goods">
              <p class="name">
                {{ detailInfo.car_order_goods.goods_name }}
              </p>
              <p class="stock">
                <span
                  >所选颜色：{{
                    detailInfo.car_order_goods.specification_name
                  }}</span
                >
              </p>
              <p class="unit_price">
                <span class="label_">￥</span>{{ detailInfo.daily_rent }}
                <span class="dec">/日租价</span>
              </p>
            </div>
          </van-col>
          <van-col
            span="24"
            class="tips tips_bottom"
            v-if="detailInfo.status >= 50 && detailInfo.status != 80"
            ><img src="../../assets/carRent/tips@2x.png" />{{
              detailInfo.status == 50
                ? "请在15-30天后携带您的身份证及驾驶证，前往提车"
                : "请保护好您的车辆"
            }}</van-col
          >
        </van-row>

        <van-row class="order_info">
          <van-col span="24" class="info_title">订单信息</van-col>
          <van-col span="24" class="member_info info1">
            订金金额：￥{{ detailInfo.deposit_amount }}
          </van-col>
          <van-col span="24" class="member_info">
            尾款金额：￥{{ detailInfo.balance_rent }}
          </van-col>
          <van-col span="24" class="member_info">
            首年保险：￥{{ detailInfo.insurance_amount }}
          </van-col>
          <template>
            <van-col span="24" class="member_info" v-if="deductAll != 0">
              共计抵扣：￥{{ deductAll
              }}<van-icon
                class="answerIcon"
                @click="showAllDeduct"
                name="question-o"
              />
            </van-col>
            <van-col
              span="24"
              class="member_info"
              v-if="
                deductAll != 0 &&
                detailInfo.deposit_pay_info &&
                detailInfo.balance_pay_info
              "
            >
              实付款：￥{{
                Number(detailInfo.deposit_pay_info.pay_amount) +
                Number(detailInfo.balance_pay_info.pay_amount)
              }}
            </van-col>
          </template>
          <van-col span="24" class="member_info">
            预计赠送红包：<span class="coin">￥{{ refundCoin }}</span>
          </van-col>
          <van-col span="24" class="member_info">
            订单编号：<span ref="copytxt">{{ detailInfo.order_num }}</span>
            <img
              class="copy"
              src="../../assets/carRent/copy@2x.png"
              @click="copyCode"
            />
          </van-col>
        </van-row>

        <van-row class="order_info">
          <van-col span="24" class="member_info info2">
            申请时间：{{ detailInfo.created_at }}
          </van-col>
          <van-col
            span="24"
            class="member_info"
            v-if="detailInfo.balance_pay_info"
          >
            尾款支付时间：{{ detailInfo.balance_pay_info.pay_time }}
          </van-col>
          <van-col span="24" class="member_info" v-if="detailInfo.status >= 60">
            租赁时间：{{ detailInfo.rent_start_date }}
          </van-col>
          <van-col span="24" class="member_info" v-if="detailInfo.status >= 60">
            到期时间：{{ detailInfo.rent_end_date }}
          </van-col>
        </van-row>
      </div>
    </div>
    <van-popup class="tipPopup" v-model="tipsShow">
      <template
        v-if="
          detailInfo.deposit_pay_info &&
          (detailInfo.deposit_pay_info.deduct_coin != 0 ||
            detailInfo.deposit_pay_info.deduct_balance != 0)
        "
      >
        <p class="title">订金抵扣</p>
        <p class="con" v-if="detailInfo.deposit_pay_info.deduct_balance != 0">
          个人余额抵扣：{{ detailInfo.deposit_pay_info.deduct_balance }}
        </p>
        <p class="con" v-if="detailInfo.deposit_pay_info.deduct_coin != 0">
          红包抵扣：{{ detailInfo.deposit_pay_info.deduct_coin }}
        </p>
      </template>

      <template
        v-if="
          detailInfo.balance_pay_info &&
          (detailInfo.balance_pay_info.deduct_coin != 0 ||
            detailInfo.balance_pay_info.deduct_balance != 0)
        "
      >
        <p class="title">尾款抵扣</p>
        <p class="con" v-if="detailInfo.balance_pay_info.deduct_balance != 0">
          个人余额抵扣：{{ detailInfo.balance_pay_info.deduct_balance }}
        </p>
        <p class="con" v-if="detailInfo.balance_pay_info.deduct_coin != 0">
          红包抵扣：{{ detailInfo.balance_pay_info.deduct_coin }}
        </p>
      </template>
      <btn
        :btntext="'知道了'"
        :btnwidth="'11.4rem'"
        :height="'3.6rem'"
        :bgcolor="'linear-gradient(to right, #49A6FF, #236DFE)'"
        :borderradius="'0.6rem'"
        :btncolor="'#fff'"
        :fontsize="'1.4rem'"
        :btnmargin="'2rem 0 0 6.9rem'"
        @btnClick="knowed"
      />
    </van-popup>
  </div>
</template>
<script>
import navbar from "../purchaseSupplier/components/nav-bar.vue";
import btn from "../purchaseSupplier/components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/carRent/reback@2x.png"),
      detailInfo: {},
      statusLabel: {
        40: "合同待签署",
        45: "合同审核中",
        50: "签署完成",
        60: "租赁中",
        70: "租赁中",
        80: "已赠送",
        "-40": "合同已驳回",
      },
      refundCoin: "0.00",
      deductAll: 0,
      tipsShow: false,
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    goBack() {
      if (this.$route.query.from) {
        this.$router.go(-1);
      } else {
        this.$router.replace("/carRent/carList");
      }
    },
    getInfo() {
      this.$api
        .post("/onorder/member/car_rental/order/detail", {
          order_num: this.$route.query.order_num,
        })
        .then((res) => {
          this.detailInfo = res;
          this.refundCoin = (
            (Number(res.balance_rent) + Number(res.deposit_amount)) /
            2
          ).toFixed(2);
          this.deductAll =
            Number(res.deposit_pay_info.deduct_coin) +
            Number(res.deposit_pay_info.deduct_balance) +
            Number(res.balance_pay_info.deduct_coin) +
            Number(res.balance_pay_info.deduct_balance);
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    copyCode() {
      const rechage_range = document.createRange();
      rechage_range.selectNode(this.$refs.copytxt);
      const rechage_selection = window.getSelection();
      if (rechage_selection.rangeCount > 0) rechage_selection.removeAllRanges();
      rechage_selection.addRange(rechage_range);
      document.execCommand("Copy");
      this.$toast("复制成功");
      rechage_selection.removeAllRanges();
    },
    goSign() {
      sessionStorage.setItem("signedBack", 3);
      let parm = {};
      if (this.detailInfo.status == 40) {
        //未签署
        parm = {
          order_id: this.detailInfo.id,
          signed: 0,
          from: "h5",
        };
      } else if (this.detailInfo.status == -40) {
        //重新签署
        parm = {
          order_id: this.detailInfo.id,
          signed: 1,
          from: "h5",
        };
      } else {
        //已签署
        sessionStorage.setItem("pdfSrc", this.detailInfo.sign_file_url);
        parm = {
          order_id: this.detailInfo.id,
          signed: 2,
          from: "h5",
        };
      }
      this.$router.push({
        path: "/carRent/pdf",
        query: parm,
      });
    },
    showAllDeduct() {
      this.tipsShow = true;
    },
    knowed() {
      this.tipsShow = false;
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.car_rent_order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .car_rent_order_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .pay_btn {
    position: fixed;
    bottom: 0.4rem;
    left: 1.6rem;
  }

  .all {
    padding: 10rem 0 0;
    box-sizing: border-box;
    height: 100%;

    .box {
      padding: 0 1.2rem;
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      .goods {
        height: auto;
        border-radius: 0.8rem;
        background: #fff;
        margin-bottom: 1.2rem;
        padding: 0.6rem 1.6rem 1rem;

        .status {
          height: 4rem;
          line-height: 4rem;
          color: #333;
          font-size: 1.4rem;
          font-weight: 700;

          .operation {
            color: #236dfe;
            font-size: 1.2rem;
            float: right;
          }
        }

        .tips {
          color: #ff4747;
          font-size: 1.2rem;
          min-height: 2.8rem;
          line-height: 2rem;
          border-radius: 0.4rem;
          background: #fff2f2;
          padding: 0.4rem 1.2rem;

          img {
            width: 1.2rem;
            margin-right: 0.6rem;
            vertical-align: middle;
          }
        }

        .tips_top {
          margin-bottom: 1.2rem;
        }

        .tips_bottom {
          margin-top: 1rem;
        }

        .goods_info {
          box-sizing: border-box;
          position: relative;

          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 10.7rem;
            height: 8.1rem;
            border-radius: 0.6rem;
          }

          .goods_r {
            padding-left: 11.7rem;

            .name {
              font-size: 1.6rem;
              color: #000;
              font-weight: 700;
              height: 4.4rem;
              line-height: 2.2rem;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              white-space: normal;
            }

            .stock {
              height: 1.8rem;
              margin: 0.4rem 0 0.8rem;

              span {
                color: #333;
                height: 1.6rem;
                line-height: 1.6rem;
                font-size: 1rem;
                font-weight: 700;
                border: solid 1px #c8c8c8;
                border-top-left-radius: 0.4rem;
                border-bottom-right-radius: 0.4rem;
                padding: 0 0.5rem;
              }
            }

            .unit_price {
              color: #ff4747;
              font-size: 1.6rem;
              font-weight: 700;
              line-height: 2.2rem;

              .label_ {
                font-size: 1rem;
              }

              .dec {
                color: #999;
                font-size: 1rem;
              }
            }
          }
        }
      }

      .order_info {
        padding: 1.6rem;
        background: #fff;
        border-radius: 1rem;
        margin-top: 1.2rem;

        .info_title {
          color: #000;
          font-size: 1.6rem;
          font-weight: 700;
          height: 2.2rem;
          line-height: 2.2rem;
        }

        .member_info {
          margin-top: 1.2rem;
          height: 2rem;
          line-height: 2rem;
          color: #333;
          font-size: 1.4rem;

          .coin {
            color: #ff4747;
          }

          .copy {
            width: 2rem;
            margin-left: 1rem;
            vertical-align: middle;
          }

          .answerIcon {
            margin-left: 1rem;
            font-size: 1.7rem;
            font-weight: 700;
            vertical-align: middle;
            margin-top: -0.2rem;
          }
        }

        .info1 {
          margin-top: 1.6rem;
        }

        .info2 {
          margin-top: 0;
        }
      }
    }
  }

  .tipPopup {
    width: 29.6rem;
    border-radius: 0.8rem;
    padding: 0 2.2rem 2.2rem;
    box-sizing: border-box;
    color: #333;

    .title {
      font-size: 1.6rem;
      font-weight: 700;
      margin-top: 3rem;
    }

    .con {
      font-size: 1.4rem;
      line-height: 2.5rem;
    }
  }
}
</style>




